











































import { Vue } from "vue-property-decorator";
import AppLayout from "@/components/app-layout.vue";
import store from "@/store";
import { mapGetters } from "vuex";
import IndividusScrollAlphabet from "./components/individus-scrollalphabet.vue";
import IndividusList from "./components/individus-list.vue";
import AppAdo from "@/components/app-ado.vue";
import { Individu } from "@/models/Individu";
import { SHOW_LOADING, CLOSE_LOADING } from "@/store/types";
import { FiltreScolarite } from "@/models/_FiltresScolarite";
export default Vue.extend({
  beforeRouteEnter(from, to, next) {
    store.dispatch(SHOW_LOADING);
    setTimeout(() => {
      store
        .dispatch("individus/fetchDataForFilter")
        .then(() => {
          store
            .dispatch("individus/fetchListIndividus", "etablissement")
            .then(() => {
              next((vm: any) => {
                store.dispatch(CLOSE_LOADING);
                vm.initScolariteFilter();
                next();
              });
            })
            .catch((error: any) => {
              store.dispatch(CLOSE_LOADING);
              next("/erreurs/" + error);
            });
        })
        .catch((error: any) => {
          store.dispatch(CLOSE_LOADING);
          next("/erreurs/" + error);
        });
    }, 250);
  },
  beforeRouteLeave(to, from, next) {
    store
      .dispatch("individus/closeFiltre", "all")
      .then(() => {
        next();
      })
      .catch((error: any) => {
        next("/erreurs/" + error);
      });
  },
  components: {
    AppLayout, 
    IndividusScrollAlphabet,
    IndividusList,
    AppAdo,
  },
  data() {
    return {
      alphabet: [...Array(26)]
        .map((_, y) => String.fromCharCode(y + 65))
        .join(""),
      autori: -2,
      filtreScolarite: new FiltreScolarite(),
    };
  },
  computed: {
    ...mapGetters("individus", [
      "getFiltredListIndividus",
      "getListClasses",
      "getListEcoles",
      "getListInstits",
      "getListNiveau",
      "getListVille",
      "getCurrentAnneeScolaire",
      "getListEtablissementScolaireNiveau",
      "getListClasseScolaireNiveau",
      "getListClasseScolaireEnseignant",
      "getIsIndividusDuJours",
    ]),
    ...mapGetters("etablissements", ["getCurrentEtablissement"]),
  },
  methods: {
    initScolariteFilter() {
      this.filtreScolarite.setListClasses(this.getListClasses);
      this.filtreScolarite.setListEtablissementScolaireNiveau(
        this.getListEtablissementScolaireNiveau
      );
      this.filtreScolarite.setListClasseScolaireNiveau(
        this.getListClasseScolaireNiveau
      );
      this.filtreScolarite.setListClasseScolaireEnseignant(
        this.getListClasseScolaireEnseignant
      );
      this.filtreScolarite.setListEcoles(this.getListEcoles);
      this.filtreScolarite.setListInstits(this.getListInstits);
      this.filtreScolarite.setListNiveau(this.getListNiveau);
      this.filtreScolarite.setCurrentAnneeScolaire(
        this.getCurrentAnneeScolaire
      );
    },
    addEnfant(event: Individu) {
      store.dispatch("individus/selectIndividu", event);
    },
    defaultLogo(event: any) {
      event.target.src = require(`@/assets/logo.png`);
    },
    filtres(params: any) {
      console.log("refresh filter", params);
      store.dispatch("individus/filtreListIndividus", params);
    },
    closeFiltre(params: string) {
      store.dispatch("individus/closeFiltre", params);
    },
    filtreAutori(e: number) {
      console.log(e);
      this.autori = e;
    },
    listIndividusJour(event: boolean) {
      store.dispatch("individus/fetchTousIndividus", event);
    },
  },
});
